import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fullscreen-exit",
  "use": "icon-fullscreen-exit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-fullscreen-exit\"><path d=\"M789.344 277.344V128H704v170.656c0 36.256 27.744 64 64 64h170.656V277.312h-149.344zM704 725.344V896h85.344v-149.344h149.344v-85.344h-170.656c-36.256 0-64 27.744-64 64zM256 661.344H85.344v85.344h149.344v149.344h85.344v-170.656c0-36.256-27.744-64-64-64zM234.656 277.344H85.312v85.344h170.656c36.256 0 64-27.744 64-64V128.032H234.624v149.344z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol